var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.campaign !== null)?_c('div',[_c('InsightsHeader',{attrs:{"campaign":_vm.campaign}}),_c('vs-row',[_c('div',{staticClass:"vx-col w-full"},[_c('InsightsContent',{attrs:{"campaign":_vm.campaign}})],1)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }